import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  store({ params }) {
    localStorage.locale = params.locale
  }
}
